export default "/images/vendor/@coreui/icons/svg/flag/cif-es.svg?53f452eb4e5e8b51cc40ad308c31f33c";